<style>
.medical-document__prescription {
  border: 0;
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}

.medical-document__prescription thead tr th {
  color: rgb(153, 153, 153);
  font-family: 'Open Sans';
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 2px;
  margin: 0;
  padding: 0 0 0.5rem;
  text-align: right;
  text-transform: uppercase;
  width: 20%;
}

.medical-document__prescription thead tr th:first-of-type {
  text-align: left;
  width: 60%;
}

.medical-document__prescription tbody tr td {
  text-align: right;
  vertical-align: top;
  width: 20%;
}

.medical-document__prescription tbody tr td:first-of-type {
  text-align: left;
  width: 60%;
}

.medical-document__prescription-text {
  color: rgb(68, 68, 68);
  font-family: 'Open Sans';
  font-size: 0.7rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  padding: 0;
}

.medical-document__prescription-text--italic {
  font-style: italic;
  font-weight: normal;
  margin-bottom: 0;
  padding-left: 1rem;
}

.medical-document__prescription-text--upper {
  text-transform: uppercase;
}
</style>

<template>
  <article class="medical-document">
    <print-header
      type="Receita Médica"
      :date="$moment(active['created_at']).format('DD/MM/YYYY')"
      :patient="patient"
      :doctor="doctor"
    />

    <table class="medical-document__prescription">
      <thead>
        <tr>
          <th>Medicamento</th>
          <th>Controlado</th>
          <th>Quantidade</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(prescriptionMedicament, index) of active['prescription_medicaments']"
          :key="index"
        >
          <td>
            <p class="medical-document__prescription-text">
              {{ prescriptionMedicament.medicament.name }}
              ({{ returnActivePrinciples(prescriptionMedicament.medicament['active_principles']) }})
              -
              {{ prescriptionMedicament.medicament.label }}
            </p>

            <p class="medical-document__prescription-text medical-document__prescription-text--italic">
              Posologia: {{ prescriptionMedicament.posology }}
            </p>

            <p
              v-if="prescriptionMedicament.note"
              class="medical-document__prescription-text medical-document__prescription-text--italic"
            >
              Observação: {{ prescriptionMedicament.note }}
            </p>
          </td>

          <td>
            <p class="medical-document__prescription-text medical-document__prescription-text--upper">
              Não
            </p>
          </td>

          <td>
            <p class="medical-document__prescription-text medical-document__prescription-text--upper">
              {{ prescriptionMedicament.quantity }}
              {{ prescriptionMedicament['medicament_prescription_quantity_unity'] }}
              {{ prescriptionMedicament.quantity > 1 ? 's' : '' }}
            </p>
          </td>
        </tr>
      </tbody>
    </table>

    <print-footer :doctor="doctor" />
  </article>
</template>

<script>
import printHeader from './_header.vue'
import printFooter from './_footer.vue'

export default {
  name: 'DrPrintTemplateMedicalPrescription',

  components: {
    printHeader,
    printFooter
  },

  props: ['formData', 'active', 'patient', 'doctor'],

  methods: {
    returnActivePrinciples (aps) {
      let arr = []
      for (let principle of aps) {
        arr.push(principle.name)
      }
      return arr.join(', ')
    }
  }
}
</script>
